import { Link } from "react-router-dom";

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  imageAlt = "",
  ctaPrimary,
  ctaSecondary,
}) {
  return (
    <section className="relative bg-white border-b border-slate-200">
      <div className="fss-container py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 fss-rise">
          {eyebrow && <div className="fss-overline">{eyebrow}</div>}
          <h1 className="mt-4 fss-headline text-4xl sm:text-5xl lg:text-6xl text-slate-900">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
          {(ctaPrimary || ctaSecondary) && (
            <div className="mt-8 flex flex-wrap gap-3">
              {ctaPrimary && (
                <Link
                  to={ctaPrimary.to}
                  className="fss-btn fss-btn-primary"
                  data-testid="page-hero-cta-primary"
                >
                  {ctaPrimary.label}
                </Link>
              )}
              {ctaSecondary && (
                <Link
                  to={ctaSecondary.to}
                  className="fss-btn fss-btn-outline"
                  data-testid="page-hero-cta-secondary"
                >
                  {ctaSecondary.label}
                </Link>
              )}
            </div>
          )}
        </div>

        {image && (
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden border border-slate-200 rounded-sm">
              <img
                src={image}
                alt={imageAlt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute top-0 left-0 w-2 h-24 bg-red-600" />
              <div className="absolute bottom-0 right-0 w-24 h-2 bg-green-700" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
